module.exports = __webpack_public_path__ + "img/smart-assistant.0b1a64c7.png";